import { useSceneRendererComponent } from "@/configurator/presentation/renderers/useSceneRendererComponent";
import type { Scene3D } from "@/configurator/utils/scene/Scene3D";

type Props = {
  onSceneReady?: (scene: Scene3D) => void;
};

export function SceneRenderer({ onSceneReady }: Props = {}) {
  const { mountRef, backgroundColor } = useSceneRendererComponent(onSceneReady);
  const isTransparent = backgroundColor === null;

  return (
    <div className="scene-renderer relative h-full w-full">
      <div
        ref={mountRef}
        className={[
          "scene-renderer__mount h-full w-full overflow-hidden",
          // Radii come from container queries in `configurator.css`; Tailwind's
          // `md:` utilities key off the viewport, which does not tell us how
          // wide the widget is inside a host page's layout.
          isTransparent ? "" : "scene-renderer__mount--framed",
        ]
          .filter(Boolean)
          .join(" ")}
        style={isTransparent ? undefined : { backgroundColor: backgroundColor }}
      />
    </div>
  );
}
